import { isNilOrEmpty } from '../../../../../server/helpers/index.mjs';

export const isSiretInvalid = (siret) => {
  const sanitizedSiret = siret.replace(/\s/g, '');
  return (
    isNilOrEmpty(sanitizedSiret) || !(sanitizedSiret.length === 9 || sanitizedSiret.length === 14)
  );
};
